import React from 'react';
import { getAcademicResultsFromStudyHistory } from '@/utilities/fulfilmentData';
import { Box, Stack, Text } from '@chakra-ui/react';
import { IStudy } from 'types';
import { CustomCollapse } from '../../../CustomCollapse/CustomCollapse';
import { useTranslation } from "react-i18next";

interface OtherQualificationsProps {
  previousStudies: Record<string, Partial<IStudy>>;
}

export function OtherQualifications({ previousStudies }: OtherQualificationsProps): React.ReactElement | null {
    const { t } = useTranslation('common');
  const studyEntries = Object.entries(previousStudies);

  if (studyEntries.length === 0) {
    return null;
  }

  return (
    <Box mt={2}>
      <CustomCollapse>
        <CustomCollapse.Trigger>{t('common:otherQualifications')}</CustomCollapse.Trigger>
        <CustomCollapse.Content>
          <Stack spacing={4}>
            {studyEntries.map(([studyId, study]) => {
              const qualifications = getAcademicResultsFromStudyHistory(study as IStudy);
              return (
                <Box key={studyId}>
                  <Text fontWeight="medium" mb={1}>
                    {study.institutionName || 'Unknown institution'}
                    {study.country && `, ${study.country}`}
                  </Text>
                  {qualifications.length > 0 ? (
                    <Stack spacing={1}>
                      {qualifications.map(({ text }, index) => (
                        <Box key={index} pl={2}>
                          <Text fontSize="sm" mb={0}>
                            {text}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  ) : (
                    <Text fontSize="sm" color="muted" pl={2}>
                      {t('common:noQualificationsProvided')}
                                                      </Text>
                  )}
                </Box>
              );
            })}
          </Stack>
        </CustomCollapse.Content>
      </CustomCollapse>
    </Box>
  );
}
